/**
 * 배달 이력 API 서비스
 */
import { apiClient } from '../../../../core/api/client';
import { 
  DeliveryHistoryResponse, 
  DeliveryHistoryRequest,
} from '../types/deliveryHistory';
import {
  DeliveryDetailRequest,
  DeliveryDetailResponse,
} from '../types/deliveryDetail';

const BASE_PATH = '/api/v1/mob/delivery';

/**
 * 배달 이력 조회 (날짜 범위)
 * GET /api/v1/mob/delivery/delivery-list
 */
export const getDeliveryHistory = async (
  params: DeliveryHistoryRequest
): Promise<DeliveryHistoryResponse> => {
  const response = await apiClient.get<DeliveryHistoryResponse>(
    `${BASE_PATH}/delivery-list`,
    { params }
  );
  return response.data;
};

/**
 * 특정 날짜 배달 이력 조회
 * GET /api/v1/mob/delivery/delivery-list
 */
export const getDeliveryHistoryByDate = async (
  params: DeliveryHistoryRequest
): Promise<DeliveryHistoryResponse> => {
  const response = await apiClient.get<DeliveryHistoryResponse>(
    `${BASE_PATH}/delivery-list`,
    { params }
  );
  return response.data;
};

/**
 * 정산 타입 조회
 * GET /api/v1/mob/delivery/pre-acct-yn
 * riderId, suppId는 토큰에 포함되어 있으므로 파라미터에서 제외
 */
export const getPreAcctYn = async (): Promise<{ preAcctYn: string }> => {
  const response = await apiClient.get<{ preAcctYn: string }>(
    `${BASE_PATH}/pre-acct-yn`
  );
  return response.data;
};

/**
 * 배달내역 상세 내역 조회
 * GET /api/v1/mob/delivery/delivery-detail
 */
export const getDeliveryDetail = async (
  params: DeliveryDetailRequest
): Promise<DeliveryDetailResponse> => {
  const response = await apiClient.get<DeliveryDetailResponse>(
    `${BASE_PATH}/delivery-detail`,
    { params }
  );
  return response.data;
};